import styled, { css } from 'styled-components';

export const Container = styled.ul`
  gap: 24px;
  width: 100%;
  display: flex;
  height: 564px;
  flex-wrap: wrap;
  margin-top: 25px;
  position: relative;

  @media (max-width: 485px) {
    justify-content: space-between;
  }

  @media (max-width: 299px) {
    gap: 20px;
  }
`;

export const Card = styled.li`
  list-style: none;

  @media (max-width: 485px) {
    width: 45%;
  }

  @media (max-width: 350px) {
    width: 44%;

    button {
      transform: scale(0.8);
    }
  }

  @media (max-width: 340px) {
    button {
      transform: scale(0.7);
    }
  }

  @media (max-width: 310px) {
    button {
      transform: scale(0.6);
    }
  }

  @media (max-width: 266px) {
    width: 100%;
  }
`;

export const ContentCard = styled.div<{ hide: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${({ hide }) =>
    hide &&
    css`
      opacity: 0;
      pointer-events: none;
    `}
`;

export const Picture = styled.img`
  width: 164px;
  height: 164px;
  object-fit: contain;

  @media (max-width: 485px) {
    width: 100%;
    height: min-content;
  }
`;

export const Name = styled.p`
  margin: 13px 0;
  font-family: 'Russo One';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: ${({ theme }) => theme.palette.text.white};
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 153px;
  margin-top: 13px;
`;
